import Slider from 'react-slick';
import { useMediaQuery } from '@material-ui/core';

import { DEVICES } from '../../../lib/breakpoints';
import cn from '../../../lib/classNames';
import AiPlaceholder from '../../Report/RiskBriefReport/AiPlaceholder/AiPlaceholder';

import risk1 from './images/risk1.svg';
import risk2 from './images/risk2.svg';
import risk3 from './images/risk3.svg';
import risk4 from './images/risk4.svg';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './SuperiorRiskIntelligence.module.scss';

type ItemType = {
	icon: string;
	title: string;
	description: string;
};

function Item(props: ItemType) {
	const { icon, title, description } = props;

	return (
		<div className={styles.item}>
			<div className={styles.text}>
				<h3 className={styles['item-title']}>{title}</h3>
				<p className={styles['item-description']}>{description}</p>
			</div>
			<img src={icon} alt={title} className={styles.icon} />
		</div>
	);
}

type SuperiorRiskIntelligenceType = {
	classPageContent?: string;
};

const itemsData = [
	{
		icon: risk1,
		title: 'Rigorous Data and Analytics',
		description:
			'We combine accredited global data with proprietary AI to quantify risks more accurately than qualitative scales or scores.',
	},
	{
		icon: risk2,
		title: 'No Regional Bias or Data Vacuum for US',
		description:
			'Our ratings include most larger US cities - which include some of the more violent top business travel destinations.',
	},
	{
		icon: risk3,
		title: 'Reduces Ambiguity',
		description:
			'We use unambiguous language about what is being measured and how to reduce risks.',
	},
	{
		icon: risk4,
		title: 'Risk Perception Tracking',
		description:
			'Features like our Risk Calibration Quiz target cognitive biases and track risk perception trends over time.',
	},
];

export default function SuperiorRiskIntelligence(props: SuperiorRiskIntelligenceType) {
	const { classPageContent } = props;
	const isMobile = useMediaQuery(DEVICES.isMobile);

	const sliderSettings = {
		arrows: false,
		autoplay: true,
		dots: true,
		swipe: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		pauseOnHover: true,
	};

	return (
		<div className={cn(styles.wrap, classPageContent)}>
			<h3 className={styles.title}>Superior Risk Intelligence</h3>
			<div className={styles.description}>
				What makes Safe-xplore the most advanced travel risk management solution?
			</div>

			{isMobile ? (
				<Slider className={styles.slider} {...sliderSettings}>
					{itemsData.map((item, idx) => (
						<div key={item.title} className={styles['slider-item']}>
							<Item {...item} />
						</div>
					))}
				</Slider>
			) : (
				<div className={styles.items}>
					{itemsData.map((item) => (
						<Item key={item.title} {...item} />
					))}
				</div>
			)}
		</div>
	);
}
